export default "/assets/images/dusty-taupe.ba33900f1c1c561c.jpg";